// src/pages/Manufacturing/manufacturingThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../apiservice/apis";
import {
  manufacturingRecordWithDetailseApi,
  manufacturingVoucherNumbereApi,
} from "../../../apiservice/manufacturing";
import { createManufacturingPayload } from "../../../utils/manufacturing";
import { pathSpliter } from "../../../lib/functions";

// Voucher number
export const fetchManufacturingNumber = createAsyncThunk(
  "manufacturing/fetchNumber",
  async (val) => {
    const res = await manufacturingVoucherNumbereApi({ entryDate: val });
    return res.data;
  }
);

// Fetch existing record
export const fetchManufacturingRecord = createAsyncThunk(
  "manufacturing/fetchRecord",
  async (mf_id, { rejectWithValue }) => {
    try {
      const res = await manufacturingRecordWithDetailseApi(mf_id);
      const data = res.data.find(m => m.mf_id === mf_id);
      if (!data) return null;
      

      // Expect API returns two sets: mDetails (production) and mciDetails (raw)
      const productionDetails = data.miDetails || data.productionDetails || [];
      const rawDetails = data.mciDetails || data.rawDetails || [];

      const productionCart = productionDetails.map((item) => {
        let serials = [];
        if (item.is_serial === "yes" && item.serials) {
          serials = item.serials.split(",").map((slNo) => ({
            serial_number: slNo,
          }));
        }
        return {
          key: item.mf_d_id || Date.now() + Math.random(),          
          item_id: item.item_id,
          product: item.item_name,
          quantity: item.item_qty,
          qty: Number(item.item_qty || 0),  
          rate: Number(item.item_rate || 0),
          amount: Number(item.item_qty || 0) * Number(item.item_rate || 0),          
          discount: item.item_discount_per || 0,
          tax_per: item.item_tax_per || 0,
          serials,
          unit_name: item.unit_name,
          unit_symbol: item.unit_symbol,
          base_unit_name: item.base_unit_name,
          conversion: item.conversion,
          per_unit_id: item.per_unit_id,
          per_unit_symbol: item.per_unit_symbol,
          per_conversion: item.per_conversion,
          display_text: item.display_text,
          // If returns use different fields, adapt here
          return_qty: item.return_qty ?? 0,
        };
      });

      const rawCart = rawDetails.map((item) => {
        let serials = [];
        if (item.is_serial === "yes" && item.serials) {
          serials = item.serials.split(",").map((slNo) => ({
            serial_number: slNo,
          }));
        }
        return {
          key: item.mci_d_id || Date.now() + Math.random(),
          item_id: item.item_id,
          product: item.item_name,
          quantity: item.raw_item_qty,          
          discount: item.item_discount_per || 0,
          tax_per: item.item_tax_per || 0,
          serials,
          qty: Number(item.raw_item_qty || 0),   // ✅ FIX
          rate: Number(item.raw_rate ?? item.raw_item_rate ?? 0),
          amount: Number(item.raw_item_total ?? 0),
          unit_name: item.unit_name,
          unit_symbol: item.unit_symbol,
          base_unit_name: item.base_unit_name,
          conversion: item.conversion,
          per_unit_id: item.per_unit_id,
          per_unit_symbol: item.per_unit_symbol,
          per_conversion: item.per_conversion,
          display_text: item.display_text,
          return_qty: item.return_qty ?? 0,
        };
      });

      return { record: data, productionCart, rawCart, trans: data.trans || [] };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Create or Update manufacturing
export const createManufacturing = createAsyncThunk(
  "manufacturing/create",
  async (location, { getState, rejectWithValue }) => {
    try {
      const state = getState().manufacturing;
      const { auth } = getState();      
      
    const mf_id = pathSpliter(location.pathname, 2) ? pathSpliter(location.pathname, 2) : 0 ;
      const payload = createManufacturingPayload(state, auth.auth_info, mf_id);

      
      

      let url = `/manufacturing/create-manufacturing`;
      if (pathSpliter(location.pathname, 2)) {
        url = `/manufacturing/update-manufacturing`;
      }

      const res = await postData(url, payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteManufacturingRecord = createAsyncThunk(
  "manufacturingRecord/delete",
  async (mf_id, { rejectWithValue }) => {
    try {
      const res = await postData("/manufacturing/manufacturing-delete", { mf_id });
      return { mf_id, message: res.data.message };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);